import Util from "@/Master/Util";

export default class RandomUtil {
    /**
     * 是否中奖, value=[0,1]
     * @param chance 概率值
     * @returns 是否中奖
     */
    static isInChance(chance: number): boolean {
        if (chance <= 0) return false;
        if (chance >= 1) return true;
        return Math.random() < chance;
    }

    /**
     * 是否中奖, 分母为 10000 的情况
     * @param chance 概率值
     * @returns 是否中奖
     */
    static isInChance10000(chance: number): boolean {
        if (chance <= 0) return false;
        if (chance >= 10000) return true;
        return RandomUtil.isInChance(chance / 10000);
    }

    /**
     * 返回一个范围内的随机整数 [min, max)
     * @param min 最小值
     * @param max 最大值
     * @returns 随机整数
     */
    static range(min: number, max: number): number {
        return Math.floor(Math.random() * (max - min)) + min;
    }

    /**
     * 返回一个范围内的随机浮点数 [min, max]
     * @param min 最小值
     * @param max 最大值
     * @returns 随机浮点数
     */
    static fromTo(min: number, max: number): number {
        return Math.random() * (max - min) + min;
    }

    /**
     * 随机返回 +1 或 -1
     * @returns +1 或 -1
     */
    static get sign(): number {
        return Math.random() < 0.5 ? -1 : 1;
    }

    /**
     * 根据权重列表随机一个序号
     * @param weights 权重数组
     * @returns 随机的索引
     */
    static randomWeightIndex(weights: number[]): number {
        const totalWeight = weights.reduce((sum, weight) => sum + weight, 0);
        if (totalWeight <= 0) return 0;

        let randomValue = Math.random() * totalWeight;
        for (let i = 0; i < weights.length; i++) {
            randomValue -= weights[i];
            if (randomValue < 0) return i;
        }
        return weights.length - 1;
    }

    /**
     * 随机返回数组中的一个元素
     * @param array 数组
     * @returns 随机元素
     */
    static arrayRandom<T>(array: T[]): T {
        return array[RandomUtil.range(0, array.length)];
    }

    /**
     * 洗牌数组
     * @param array 数组
     * @returns 洗牌后的数组
     */
    static shuffle<T>(array: T[]): T[] {
        for (let i = array.length - 1; i > 0; i--) {
            const j = RandomUtil.range(0, i + 1);
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }

    /**
     * 根据概率值计算是否命中
     * @param prob 几率（0-10000）
     * @returns 是否命中
     */
    static getRandomProb(prob: number): boolean {
        const totalProb = 10000;
        return Math.random() * totalProb < prob;
    }

    /**
     * 根据权重列表随机返回对应值
     * @param weights 权重数组
     * @param values 值数组
     * @returns 随机值
     */
    static getRandomByWeight(weights: number[], values: number[]): number {
        const index = RandomUtil.randomWeightIndex(weights);
        return values[index];
    }
}




// 使用示例
// console.log(RandomUtil.isInChance(0.5)); // 50%概率
// console.log(RandomUtil.range(1, 10)); // 随机整数 [1,10)
// console.log(RandomUtil.shuffle([1, 2, 3, 4])); // 打乱数组
